module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-bottom"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('small', [_vm._v(_vm._s(_vm.copyright))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "./login"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo02.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-514d91dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoginFooter.vue
// module id = 1928
// module chunks = 0